import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PendingChange } from '@/shared/config';

import { ToothWithDetections } from '@/entities/tooth';

type ToothNumberEditState = {
  pendingChanges: PendingChange[];
  selectedTooth: ToothWithDetections | null;
};

const initialState: ToothNumberEditState = {
  pendingChanges: [],
  selectedTooth: null,
};

type DetectionID = string;

export const toothNumberEditSlice = createSlice({
  name: 'toothNumberEdit',
  initialState,
  reducers: {
    addPendingChange: (state, action: PayloadAction<PendingChange>) => {
      const existingIndex = state.pendingChanges.findIndex(
        (change) =>
          change.tooth.detectionID === action.payload.tooth.detectionID,
      );
      if (existingIndex >= 0) {
        state.pendingChanges[existingIndex] = action.payload;
      } else {
        state.pendingChanges.push(action.payload);
      }
    },
    removePendingChange: (state, action: PayloadAction<DetectionID>) => {
      state.pendingChanges = state.pendingChanges.filter(
        (change) => change.tooth.detectionID !== action.payload,
      );
    },
    clearPendingChanges: (state) => {
      state.pendingChanges = [];
    },
    setSelectedTooth: (
      state,
      action: PayloadAction<ToothWithDetections | null>,
    ) => {
      state.selectedTooth = action.payload;
    },
    addPendingRemove: (state, action: PayloadAction<ToothWithDetections>) => {
      const existingIndex = state.pendingChanges.findIndex(
        (change) => change.tooth.detectionID === action.payload.detectionID,
      );
      const change = {
        tooth: action.payload,
        newNumber: -1,
        SupernumeraryIndex: 0,
      };
      if (existingIndex >= 0) {
        state.pendingChanges[existingIndex] = change;
      } else {
        state.pendingChanges.push(change);
      }
    },
    resetState: () => initialState,
  },
});

export const toothNumberEditActions = toothNumberEditSlice.actions;
export const toothNumberEditReducer = toothNumberEditSlice.reducer;
